import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FeedbackDialogComponent } from './feedback-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  constructor(private modalService: NgbModal) {}

  open(to: string, subject: string, body: string) {
    const modalRef = this.modalService.open(FeedbackDialogComponent, { centered: true });
    modalRef.componentInstance.to = to;
    modalRef.componentInstance.subject = subject;
    modalRef.componentInstance.body = body;

    return modalRef.result; // resolves when closed
  }
}
